//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start
import { uniqBy } from "lodash";
import { memo, useEffect, useState, useCallback, useMemo, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { sendTouchlineRequest } from "../../apis/web_socket";
import { BzButton, BzMasterAgGrid, BzModal, BzModalBody, BzToastMessage } from "../../components";
import { getAlerts } from "../../redux/actions/alerts";
import { handleModal, handleModalData } from "../../redux/actions/modals";
import { toastConfig } from "../../redux/actions/toast";
import { APP_INFO_PARAMS, GRID_ROW_SELECTION_TYPE, MARKET_SEGMENT_ID, ORDER_ENTRY_BUTTON_TOGGLE, SUCCESSFULL_DELETE_ALERET_MESSAGE, TL_INDEX, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import AlertGridDetails from "./AlertGridDetails";
import DeleteAlertConfirmModal from "./DeleteAlertConfirmModal";
import SetAlertModal from "./SetAlertModal";
import { ALERT_GRID_REF, convertAlertToWatchlistGrid, displayZeroStateForGrid, getApiExchangeNameFromMktSegId, getAppInfoData, getMappedMktSegIdFromApiExchangeName, gridDateFilter, isGuestUser, openOrderEntryModal, openOverviewModal, setAlertGridRef } from "../../utils/global_functions";
import { WatchlistGridPopover } from "../Watchlist";
import { StatusChip } from "../Orders";
import DeleteAlertSuccessfull from "./DeleteAlertSuccessfull";
import WatchlistSymbolColumn from "../Watchlist/WatchlistSymbolColumn";
import moment from "moment";
import ZeroStates from "../ZeroStates";
import { getWfhTouchlineLastTick } from "../../redux/actions/wfh";
import { useWFHMessages } from "../../hooks";
import GridHeaderSearch from "../GridHeaderSearch";
import { getScripOrderInfo, getSpreadOrder, updateIsBuyOrSell } from "../../redux/actions/orders";
import GridHeaderCheckbox from "../GridHeaderCheckbox";


const AlertGrid = ({ bCheckBoxSelect, setBCheckBoxSelect, toggleAlertTab, bIsAlertTab, setIsGlobalSearch }) => {
    setAlertGridRef(useRef());

    const dispatch = useDispatch();
    const arrAlerts = useSelector(state => state?.alerts?.arrAlerts);
    const trigerredAlerts = useSelector(state => state?.alerts?.trigerredAlerts);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const modals = useSelector(state => state?.modals?.modals);
    const [arrSelectedDeleteAlert, setArrSelectedDeleteAlert] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false); {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts */ }
    const objCFT = useSelector(state => state?.auth?.objCFT);
    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- Start 
    const [arrAlertRowData, setArrAlertRowData] = useState([]);
    useEffect(() => {
        if (bIsAlertTab) {
            setArrAlertRowData(arrAlerts);
        } else {
            setArrAlertRowData(trigerredAlerts);
        }
    }, [bIsAlertTab, arrAlerts, trigerredAlerts]);
    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- End

    const handleSetAlertShow = () => {
        dispatch(handleModalData({ isSearchable: true }));
        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };
    useEffect(() => {
        if (objLoginSession?.data?.user_id) {
            dispatch(getAlerts(objLoginSession?.data?.user_id));
        }
    }, [dispatch]);
    useEffect(() => {
        return (() => {
            toggleAlertTab('alert');
        });
    }, []);
    const handleDeleteAlert = () => {
        //ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve : Added condition  - Start
        // {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- Start */ }
        setIsDeleting(true);
        // {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- End */ }
        if (bIsAlertTab && arrAlerts.length > 0) {
            if (bCheckBoxSelect) {
                ALERT_GRID_REF?.current?.api?.deselectAll();
                setBCheckBoxSelect(false);
                dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove Selected Alerts <div className='notification-count font-regular ms-2'>{ALERT_GRID_REF.current.api.getSelectedRows()?.length < 10 && ALERT_GRID_REF.current.api.getSelectedRows()?.length !== 0 ? '0' + ALERT_GRID_REF.current.api.getSelectedRows()?.length : ALERT_GRID_REF.current.api.getSelectedRows()?.length}</div></div>, button: [{ btnName: "Close", type: "CLOSE_REMOVE_ALERT_TOASTER", className: "btn btn-outline-active ms-3" }, { btnName: "Remove Alert", type: "REMOVE_ALERT", className: "btn btn-outline-active ms-3", bIsDisabled: true }] })); //{/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/ }
            }
            setTimeout(() => {
                ALERT_GRID_REF?.current?.columnApi?.setColumnVisible('action', false);
                ALERT_GRID_REF?.current?.api?.sizeColumnsToFit();
            }, 5);
        }
        else {
            if (trigerredAlerts.length > 0) {
                if (bCheckBoxSelect) {
                    ALERT_GRID_REF?.current?.api?.deselectAll();
                    setBCheckBoxSelect(false);
                    dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove Selected Alerts <div className='notification-count font-regular ms-2'>{ALERT_GRID_REF.current.api.getSelectedRows()?.length < 10 && ALERT_GRID_REF.current.api.getSelectedRows()?.length !== 0 ? '0' + ALERT_GRID_REF.current.api.getSelectedRows()?.length : ALERT_GRID_REF.current.api.getSelectedRows()?.length}</div></div>, button: [{ btnName: "Close", type: "CLOSE_REMOVE_ALERT_TOASTER", className: "btn btn-outline-active ms-3" }, { btnName: "Remove Alert", type: "REMOVE_ALERT", className: "btn btn-outline-active ms-3", bIsDisabled: true }] }));
                }
                setTimeout(() => {
                    ALERT_GRID_REF?.current?.columnApi?.setColumnVisible('action', false);
                    ALERT_GRID_REF?.current?.api?.sizeColumnsToFit();
                }, 5);
            }
        }
        //ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve : Added condition  - End 
    };

    const onRowSelected = useCallback((e) => {
        if (!bCheckBoxSelect) {
            dispatch(toastConfig({ renderSingle: true, show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove Selected Alerts <div className='notification-count font-regular ms-2'>{ALERT_GRID_REF.current.api.getSelectedRows()?.length < 10 && ALERT_GRID_REF.current.api.getSelectedRows()?.length !== 0 ? '0' + ALERT_GRID_REF.current.api.getSelectedRows()?.length : ALERT_GRID_REF.current.api.getSelectedRows()?.length}</div></div>, button: [{ btnName: "Close", type: "CLOSE_REMOVE_ALERT_TOASTER", className: "btn btn-outline-active ms-3" }, { btnName: "Remove Alert", type: "REMOVE_ALERT", className: "btn btn-light ms-3", bIsDisabled: ALERT_GRID_REF.current.api.getSelectedRows()?.length === 0 }] }));
            setArrSelectedDeleteAlert(ALERT_GRID_REF.current.api.getSelectedRows()); //ManasaB : 14/12/2023 : Corrected wrong class name : Alert SAT bug fixing
        }
    }, [ALERT_GRID_REF?.current?.api?.getSelectedRows(), bIsAlertTab]);
    const handleToast = (type) => {
        switch (type) {
            case 'CLOSE': {
                dispatch(toastConfig({}));

                break;
            }
            case 'CLOSE_REMOVE_ALERT_TOASTER': {
                setBCheckBoxSelect(true);
                dispatch(toastConfig({ show: false }));
                setArrSelectedDeleteAlert([]);
                onChangeGridHeaderSearch({ target: { value: null } });
                setTimeout(() => {
                    ALERT_GRID_REF?.current?.api?.deselectAll();
                    ALERT_GRID_REF?.current?.columnApi?.setColumnVisible('action', true);
                    ALERT_GRID_REF?.current?.api?.sizeColumnsToFit();
                }, 5);
                dispatch(handleModal([{ "DELETE_ALERT_SUCCESS_MODAL": false }, { "DELETE_ALERT_CONFIRM_MODAL": false }]));
                break;
            }
            case 'REMOVE_ALERT': {
                dispatch(handleModal([{ "DELETE_ALERT_CONFIRM_MODAL": true }]));

                break;
            }
            //ManasaB : 14/12/2023 : Added default  - Start
            default: {
                break;
            }
            //ManasaB : 14/12/2023  : Added default - End
        }
    };


    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- Start 
    const arrUniqAlert = useMemo(() => {
        if (arrAlertRowData?.length > 0) {
            return uniqBy(arrAlertRowData, 'mktIdToken');
        } else {
            return [];
        }
    }, [arrAlertRowData]);
    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- End


    let strSearch = null;

    const onChangeGridHeaderSearch = useCallback((e) => {
        strSearch = e?.target?.value;
        ALERT_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(ALERT_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);

    useEffect(() => {
        onChangeGridHeaderSearch({ target: { value: null } });
    }, [bIsAlertTab]);

    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            // {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- Start */ }
            if (isDeleting) {
                strSearch = null;
                setIsDeleting(false);
                return true;
            }
            // {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- End */ }
            if (!strSearch) {
                return true;
            } else {
                const keywords = strSearch?.toString()?.toLowerCase()?.split(' ');
                let strRowData = node?.data?.symbol + node?.data?.exchange + node?.data?.expiryDate + node?.data?.nStrikePrice1 + node?.data?.instrument + node?.data?.optionType + node?.data?.series;
                return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
            }
        },
        [strSearch]
    );

    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- Start 
    const getRowId = useCallback((params) => {
        if (params?.data) {
            return params?.data?.alertUniqueId;
        } else {
        }
    }, []);

    const updateAlertWithTouchlineData = (arrTouchLineData) => {

        if (arrAlertRowData?.length > 0) {
            let arrFilt = arrAlertRowData?.filter((alert) => alert?.mktIdToken === arrTouchLineData[TL_INDEX.SEGMENT_ID]?.toString() + '_' + arrTouchLineData[TL_INDEX.TOKEN]?.toString());
            const arrAlertToBeUpdated = arrFilt?.map((alert) => {
                return {
                    ...alert,
                    ltp: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE],
                    changeInPrice: arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
                    changeInPercent: arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                    netChangeIndicator: arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR]
                };
            });


            if (arrAlertToBeUpdated?.length > 0) {
                ALERT_GRID_REF?.current?.api?.applyTransaction({
                    update: arrAlertToBeUpdated
                });
            }
        } else { }

    };
    useWFHMessages('touchline', (e) => {
        updateAlertWithTouchlineData([...e.detail]);
    });
    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- End 


    useEffect(() => {
        if (arrUniqAlert?.length > 0) {
            const arrAlertsForSubscription = arrUniqAlert?.map((scrip) => {
                return { exchangeId: scrip.segmentId, token: scrip.nToken };

            });
            sendTouchlineRequest(arrAlertsForSubscription);

        }

    }, [arrAlertRowData, arrUniqAlert]);

    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- Start 
    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        setTimeout(() => {

            if (arrUniqAlert?.length > 0) {
                arrUniqAlert?.forEach((each) => {
                    let key = each?.mktIdToken;
                    if (objLastTickData[key]) {
                        updateAlertWithTouchlineData(objLastTickData[key]);

                    }
                });
            }
        }, 50);

    }, [arrUniqAlert]);
    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- Start 
    const handleSelectSpreadOrderModel = (spreadArr, strBuySell = "SELL") => {
        dispatch(updateIsBuyOrSell(strBuySell));
        var spreadPaylod =
        {
            "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),
            "symbol": spreadArr[WATCHLIST_GRID_INDEX.SYMBOL],
            "token": spreadArr[WATCHLIST_GRID_INDEX.TOKEN]
        };
        dispatch(getSpreadOrder(spreadPaylod));


        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, true]));
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: spreadArr };
        dispatch(getScripOrderInfo(objScrpinfo));
        dispatch(handleModalData({ data: { spreadArr: spreadArr, orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);

    };
    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- End 

    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- End 
    const alertCellRendererParams = (props) => {
        return { arrRowData: convertAlertToWatchlistGrid(props?.data), isShowRowPopover: false, setIsGlobalSearch: setIsGlobalSearch, handleSelectSpreadOrderModel };
    };

    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added filters -- Start 
    const filterOptions = [
        'equals',
        'notEqual',
        'lessThan',
        'lessThanOrEqual',
        'greaterThan',
        'greaterThanOrEqual',
        'inRange',
        'blank',
        'notBlank'
    ];

    const getFilterDataForGrid = ({ filterOption, value, filterText }) => {
        if (filterText == null) {
            return false;
        } else {
            switch (filterOption) {
                case 'equals': {
                    return parseFloat(filterText) === parseFloat(value);
                }
                case 'notEqual': {
                    return parseFloat(filterText) !== parseFloat(value);
                }
                case 'lessThan': {
                    return parseFloat(value) < parseFloat(filterText);
                }
                case 'lessThanOrEqual': {
                    return parseFloat(value) <= parseFloat(filterText);
                }
                case 'greaterThan': {
                    return parseFloat(value) > parseFloat(filterText);
                }
                case 'greaterThanOrEqual': {
                    return parseFloat(value) >= parseFloat(filterText);
                }
                case 'inRange': {
                    const agFilterModel = ALERT_GRID_REF?.current?.api?.getFilterModel();
                    if (Object?.keys(agFilterModel)?.length > 0) {
                        const fromValue = agFilterModel[Object?.keys(agFilterModel)[0]].filter;
                        const toValue = agFilterModel[Object?.keys(agFilterModel)[0]].filterTo;
                        return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                    } else {
                        return false;
                    }
                }
                case 'blank': {
                    return false;
                }
                case 'notBlank': {
                    return true;
                }
                default:
                    return false;
            }
        }
    };
    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Filters  -- End 

    //Deepti B - 06-07-2014 BT-107432 Sorting issue fixes --Start
    const sortingComparator = useCallback((number1, number2) => {
        number1 = parseFloat(number1);
        number2 = parseFloat(number2);
        if (number1 === null || isNaN(number1)) {
            return 0.00;
        }
        if (number2 === null || isNaN(number2)) {
            return 0.00;
        }
        return number1 - number2;

    }, []);
    //Deepti B - 06-07-2014 BT-107432 Sorting issue fixes --End
    const arrAlertColDef = [
        {
            colId: "check",
            headerComponent: GridHeaderCheckbox,
            headerCheckboxSelection: true,
            hide: bCheckBoxSelect,
            checkboxSelection: true,
            pinned: 'left',
            width: '40'
        },
        { field: 'action', width: '100', pinned: 'left', headerName: 'ACTION', flex: 1, cellRenderer: AlertGridDetails, cellRendererParams: { setArrSelectedDeleteAlert: setArrSelectedDeleteAlert, bIseditButtonShow: bIsAlertTab }, },
        {
            field: '', pinned: 'left', headerName: 'SCRIP DESCRIPTION', cellRenderer: ({ data: arrRowData, value, ...props },) => <WatchlistGridPopover arrRowData={arrRowData}  {...props} >
                <WatchlistSymbolColumn arrRowData={arrRowData} value={value} {...props} />
            </WatchlistGridPopover>, cellRendererParams: alertCellRendererParams,
            valueGetter: (params) => {
                const myColumn = params.data;
                return `${myColumn?.symbol} `;
            }, filter: 'agTextColumnFilter',
            headerComponent: GridHeaderSearch,
            headerComponentParams: { onChangeGridHeaderSearch, gridRef: ALERT_GRID_REF }
        },
        {
            // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts -- Start 
            field: 'ltp', headerName: 'LTP', filter: 'agTextColumnFilter', flex: 1,
            cellClassRules: {

                'background-positive color-active-text': params => params?.data?.netChangeIndicator === 'U',
                'background-negative color-active-text': params => params?.data?.netChangeIndicator === 'D',
                '': params => params?.data?.netChangeIndicator === 'S',
            }, filterParams: {
                textMatcher: getFilterDataForGrid,
                filterOptions: filterOptions,
            },
            comparator: sortingComparator
        },
        {
            field: 'changeInPrice', headerName: 'CHANGE', filter: 'agTextColumnFilter', flex: 1,
            cellClassRules: {
                'color-positive': params => params?.data?.changeInPrice?.split("")[0] === '+',
                'color-negative': params => params?.data?.changeInPrice?.split("")[0] === '-',
            }, filterParams: {
                textMatcher: getFilterDataForGrid,
                filterOptions: filterOptions,
            },
            comparator: sortingComparator
        },
        {
            field: 'changeInPercent', headerName: '% CHANGE', filter: 'agTextColumnFilter', flex: 1,
            cellClassRules: {
                'color-positive': params => params?.data?.changeInPercent?.split("")[0] === '+',
                'color-negative': params => params?.data?.changeInPercent?.split("")[0] === '-',
            }, filterParams: {
                textMatcher: getFilterDataForGrid,
                filterOptions: filterOptions,
            },
            comparator: sortingComparator
        },
        // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts -- End 
        {
            field: 'displayCreateDate', headerName: 'CREATED', filter: 'agDateColumnFilter', flex: 1, filterParams: {
                comparator: gridDateFilter
            },
        },
        { field: 'triggeredTime', headerName: 'TRIGGERED', flex: 1, filter: 'agDateColumnFilter', hide: bIsAlertTab },
        { field: 'alertCondition', headerName: 'ALERT CONDITION', flex: 1, filter: 'agTextColumnFilter', },
        { field: 'status', headerName: 'STATUS', flex: 1, cellRenderer: StatusChip, cellRendererParams: { bisFromAlert: true, strClass: 'd-flex justify-content-center align-items-center mt-2' } },//Azeem K  14-12-2023:added bisFromAlert flag for green colour chip for active alert
        { field: 'expiration', headerName: 'EXPIRY', flex: 1, },
    ];

    const selectionColumnDef = useMemo(() => {
        if (bCheckBoxSelect) {
            return {
                pinned: 'left',
                hide: true,
            };
        } else {
            return {
                pinned: 'left',
                hide: false,
                headerCheckboxSelection: true
            };



        };
    }, [bCheckBoxSelect]);


    const rowSelection = useMemo(() => {
        return {
            mode: bCheckBoxSelect ? GRID_ROW_SELECTION_TYPE.SINGLE_ROW : GRID_ROW_SELECTION_TYPE.MULTI_ROW,
            checkboxes: true
        };
    }, [bCheckBoxSelect]);

    //Azeem Khan : 24-04-2024 : BT-107432 -  Breeze - Alerts - Start
    const bINesperAlert = getAppInfoData(APP_INFO_PARAMS.APP_NESPER_ALERT);
    //Azeem Khan : 24-04-2024 : BT-107432 -  Breeze - Alerts - End
    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- Start 
    const isOpen = useSelector(state => state?.addendumreducer?.isOpen);

    const bISWatchlistShrtCutsAllow = useMemo(() => {

        return !Object.keys(modals)?.some((eachModal) => modals[eachModal]) && !isOpen; //isOpen is state of addendum modal

    }, [modals, isOpen]);

    const handleBuySell = (buySell) => {
        if (!isGuestUser()) {
            if (bISWatchlistShrtCutsAllow) {
                if (ALERT_GRID_REF?.current?.api.getSelectedRows().length > 0) {
                    const arrSelectedRowScripData = convertAlertToWatchlistGrid(ALERT_GRID_REF?.current?.api?.getSelectedRows()[0]);
                    const bIsShowingGridCheckboxes = ALERT_GRID_REF?.current?.columnApi?.getColumn(
                        ALERT_GRID_REF?.current?.columnApi?.columnModel?.columnDefs[0]?.colId
                    )?.visible;
                    if (!bIsShowingGridCheckboxes && arrSelectedRowScripData?.length > 0) {
                        if (arrSelectedRowScripData[WATCHLIST_GRID_INDEX?.NSPREAD] == 1) {
                            if (objCFT?.MULTILEG) {
                                handleSelectSpreadOrderModel(arrSelectedRowScripData, 'SELL');//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
                                openOrderEntryModal(arrSelectedRowScripData, arrSelectedRowScripData, objLoginSession, null, null, buySell);

                            } else {
                                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Currently you are not allowed to place orders in Multileg .` }));
                            }
                        } else {
                            openOrderEntryModal(arrSelectedRowScripData, arrSelectedRowScripData, objLoginSession, null, null, buySell);
                        }
                    } else { }
                }
            }
        } else {
            dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
        }
    };

    // useSingleKey('f1', (e) => {

    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
    // });
    // useSingleKey('f2', (e) => {

    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.SELL);
    // });

    const handleOverview = (e) => {
        e.preventDefault(); // Prevent the default browser behavior for F5 key press
        if (ALERT_GRID_REF?.current?.api.getSelectedRows().length > 0 && bISWatchlistShrtCutsAllow) {
            const arrSelectedRowScripData = convertAlertToWatchlistGrid(ALERT_GRID_REF?.current?.api?.getSelectedRows()[0]);
            const bIsShowingGridCheckboxes = ALERT_GRID_REF?.current?.columnApi?.getColumn(
                ALERT_GRID_REF?.current?.columnApi?.columnModel?.columnDefs[0]?.colId
            )?.visible;

            if (!Boolean(bIsShowingGridCheckboxes) && arrSelectedRowScripData?.length > 0) {
                openOverviewModal(false, arrSelectedRowScripData, false, false, dispatch, {});
            }
            else { }
        };

    };

    // useSingleKey('f5', handleOverview);

    // useSingleKey('enter', (e) => {
    //     if (bISWatchlistShrtCutsAllow) {
    //         handleOverview(e);
    //     }
    // }
    // );
    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- End 

    const handleRefreshAlert = () => {
        if (objLoginSession?.data?.user_id) {
            dispatch(getAlerts(objLoginSession?.data?.user_id));
        }
    };
    const handleKeyEvents = useCallback((e) => {
        let key = e?.key?.toLowerCase();
        switch (key) {
            case 'f1':
                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
                break;
            case 'f2':
                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                break;
            case 'f5':
                handleOverview(e);
                break;
            case 'enter':
                if (bISWatchlistShrtCutsAllow) {
                    handleOverview(e);
                }
                break;
            default: break;

        }
    }, [bISWatchlistShrtCutsAllow]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyEvents);
        return () => {
            document.removeEventListener('keydown', handleKeyEvents);
        };
    }, [handleKeyEvents]);
    return (
        <Container fluid className='p-0 hamburger-set-alert'>
            <BzToastMessage btnClickHandler={handleToast} />
            <Row className='g-0 pb-3'>
                <Col md={9} className='d-flex justify-content-start align-items-center'>
                    {bIsAlertTab && <BzButton data-testid="alert-grid-set-alert-button" className='btn btn-outline btn-sm d-flex align-items-center' disabled={!bCheckBoxSelect || arrSelectedDeleteAlert?.length > 0}>
                        <div className='icon-12 icon-add-circle-fill icon-primary me-2'></div>
                        <span className='font-medium' onClick={handleSetAlertShow}>Set Alert</span>
                    </BzButton>}
                </Col>
                <Col md={3} className='d-flex justify-content-end  align-items-center'>
                    <div data-testid="alert-grid-refresh-button" className='d-flex align-items-center cursor-pointer focus p-1' onClick={handleRefreshAlert}>
                        <div className='icon-16 icon-refresh background-textual-link-withicon me-2'></div>
                        <div className='font-medium font-size3 color-textual-link-withicon p-t-2'>Refresh</div>
                    </div>
                    {/* ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve : Added condition  - Start */}
                    {/* <div className='icon-16 icon-search icon-dark ms-3'></div>
                    <div className='icon-16 icon-searchfilter icon-dark ms-3'></div> */}
                    {/* ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve : Added condition  - End */}
                    {(!bIsAlertTab && !bINesperAlert) || bIsAlertTab ? <div data-testid="alert-grid-delete-button" className={`icon-16 icon-delete ${(bIsAlertTab && arrAlerts?.length <= 0) || (!bIsAlertTab && trigerredAlerts?.length <= 0) ? 'icon-grey' : 'icon-dark'}  ms-3`} onClick={handleDeleteAlert}></div> : null}
                </Col>
            </Row>
            <Row className='g-0'>
                {/* Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - Start */}
                {
                    (bIsAlertTab && arrAlerts?.length > 0) || (!bIsAlertTab && trigerredAlerts?.length > 0) ?
                        <BzMasterAgGrid
                            testId = 'alert-log-grid'
                            selectionColumnDef={selectionColumnDef}
                            isCompress={true}
                            suppressRowClickSelection={false}
                            arrColumnData={arrAlertColDef}
                            arrRowData={arrAlertRowData} className='ag-theme-alpine hamburger-set-alert-grid'
                            onRowSelected={onRowSelected} rowSelection={rowSelection} ref={ALERT_GRID_REF}
                            rowClass='font-enlarge' isExternalFilterPresent={isExternalFilterPresent}
                            doesExternalFilterPass={doesExternalFilterPass} getRowId={getRowId} /> : //  {/* Bhagyashri P [23-11-2023] : BT-107432 Set Alerts - class changes */}
                        <div className='zero-state-alerts zero-state-alerts-xxl'>
                            <ZeroStates subText={bIsAlertTab ? "No alerts available" : "No alerts triggered yet!"} icon='icon-64 icon-alert icon-grey mb-3 mrgauto' />
                        </div>
                }
                {/* Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - End */}

                {/* Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings */}
            </Row>
            <SetAlertModal />
            <DeleteAlertConfirmModal arrSelectedDeleteAlert={arrSelectedDeleteAlert} setArrSelectedDeleteAlert={setArrSelectedDeleteAlert} />
            <BzModal show={modals['DELETE_ALERT_SUCCESS_MODAL']} >
                <BzModalBody>
                    <DeleteAlertSuccessfull strMessage={bIsAlertTab ? SUCCESSFULL_DELETE_ALERET_MESSAGE.ACTIVE_ALERT : SUCCESSFULL_DELETE_ALERET_MESSAGE.TRIGGERED_ALERT} />
                </BzModalBody>
            </BzModal>
        </Container>
    );
};
export default memo(AlertGrid);
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End